module.exports = __webpack_public_path__ + "assets/img/comments_bg.e5eddba3.png";